module.exports = __webpack_public_path__ + "docs/errp-1.5.pdf";